/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCubeUnfolded = createReactComponent("outline", "cube-unfolded", "IconCubeUnfolded", [["path", { "d": "M2 15h10v5h5v-5h5v-5h-10v-5h-5v5h-5z", "key": "svg-0" }], ["path", { "d": "M7 15v-5h5v5h5v-5", "key": "svg-1" }]]);

export { IconCubeUnfolded as default };
//# sourceMappingURL=IconCubeUnfolded.mjs.map
